import React, { useRef, useState, useEffect } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';

import rm from '../assets/rajawali.png';
import ci from '../assets/ci4.png';
import sl from '../assets/schedulink.png';
import pc from '../assets/poly.png';
import mt from '../assets/mtnc.png';
import am from '../assets/apimovie.png';
import pv from '../assets/petventory.png';
import sp from '../assets/selfpor.png';
import lh from '../assets/linkhub.png';
import bpt from '../assets/berg.png';

import {
  SiPhp,
  SiJavascript,
  SiLaravel,
  SiBootstrap,
  SiCodeigniter,
  SiPython,
  SiHtml5,
  SiCss3,
  SiNextdotjs,
  SiTailwindcss,
  SiTypescript,
  SiPrisma,
  SiReact,
  SiNetlify,
  SiVercel,
  SiPostgresql,
  SiGit,
} from 'react-icons/si';

const projects = [
  {
    title: 'Trip Planner',
    img: bpt,
    description: 'Digital presentation event trip planner.',
    tech: [<SiReact key="react.js" />, <SiTailwindcss key="tailwindcss" />, <SiJavascript key="javascript" />, <SiVercel key="vercel" />, <SiGit key="git" />],
    live: 'https://berg-puntang-trip.vercel.app',
    github: 'https://github.com/hugowrtma/berg-puntang-trip',
    category: 'personal project',
  },
  {
    title: 'Linkhub',
    img: lh,
    description: 'My personalized digital hub, a custom-built Linktree alternative.',
    tech: [<SiReact key="react.js" />, <SiTailwindcss key="tailwindcss" />, <SiJavascript key="javascript" />, <SiVercel key="vercel" />, <SiGit key="git" />],
    live: 'https://linkhub-hugo.vercel.app',
    github: 'https://github.com/hugowrtma/Linkhub',
    category: 'personal project',
  },
  {
    title: 'Petventory',
    img: pv,
    description: 'Petventory is a simple and efficient platform for managing your pet inventory. Easily track, add, update, and delete.',
    tech: [<SiNextdotjs key="next.js" />, <SiTailwindcss key="tailwindcss" />, <SiTypescript key="typescript" />, <SiPrisma key="prisma" />, <SiPostgresql key="postgresql" />, <SiGit key="git" />],
    live: 'https://petventory.vercel.app',
    github: 'https://github.com/hugowrtma/petventory',
    category: 'personal project',
  },
  {
    title: 'Self Portofolio',
    img: sp,
    description: 'My portofolio website.',
    tech: [<SiReact key="react.js" />, <SiTailwindcss key="tailwindcss" />, <SiJavascript key="javascript" />, <SiNetlify key="netlify" />, <SiGit key="git" />],
    live: 'https://hugowrtma.site',
    github: 'https://github.com/hugowrtma/self-portofolio',
    category: 'personal project',
  },
  {
    title: 'Schedulink',
    img: sl,
    description: 'Scheduling optimization using Ant Colony Algorithm in Laravel - Final University Project.',
    tech: [<SiLaravel key="laravel" />, <SiPhp key="php" />, <SiJavascript key="javascript" />, <SiBootstrap key="bootstrap" />, <SiGit key="git" />],
    live: '#',
    github: 'https://github.com/hugowrtma/CourseSchedulling',
    category: 'coursework project',
  },
  {
    title: 'Rajawali Merah',
    img: rm,
    description: 'E-commerce with PHP, JS, Bootstrap, and payment gateway.',
    tech: [<SiPhp key="php" />, <SiJavascript key="js" />, <SiBootstrap key="bootstrap" />, <SiGit key="git" />],
    live: '#',
    github: '#',
    category: 'team project',
  },
  {
    title: 'Polyclinic Appointment',
    img: pc,
    description: 'Polyclinic management system with CRUD features.',
    tech: [<SiPhp key="php" />, <SiBootstrap key="bootstrap" />, <SiGit key="git" />],
    live: '#',
    github: 'https://github.com/hugowrtma/PolyCRUD',
    category: 'coursework project',
  },
  {
    title: 'Shop Us',
    img: ci,
    description: 'E-commerce using CodeIgniter 4 with RBAC and cart.',
    tech: [<SiCodeigniter key="ci4" />, <SiPhp key="php" />, <SiGit key="git" />],
    live: '#',
    github: 'https://github.com/hugowrtma/ProjectCi4',
    category: 'coursework project',
  },
  {
    title: 'Hugo Movie',
    img: am,
    description: 'A simple movie search engine using API',
    tech: [<SiHtml5 key="html" />, <SiCss3 key="css" />, <SiJavascript key="javascript" />, <SiGit key="git" />],
    live: '#',
    github: 'https://github.com/hugowrtma/API',
    category: 'coursework project',
  },
  {
    title: 'Ticketing System',
    img: mt,
    description: 'On going, Still developing.',
    tech: [<SiPython key="python" />, <SiBootstrap key="bootstrap" />, <SiGit key="git" />],
    live: '#',
    github: '#',
    category: 'personal project',
  },
];

const categories = [
  'all',
  'personal project',
  'team project',
  'freelance project',
  'course project',
  'coursework project',
];

const fadeMotion = {
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.5,
      ease: 'easeOut',
    },
  }),
  hidden: {
    opacity: 0,
    y: 30,
    transition: {
      duration: 0.5,
    },
  },
};

const RecentWorks = () => {
  const containerRef = useRef(null);
  const isInView = useInView(containerRef, { once: true, amount: 0.4 });

  const [selectedProject, setSelectedProject] = useState(null);
  const [showMoreProjects, setShowMoreProjects] = useState(false);
  const [filter, setFilter] = useState('all');
  const [filterOpen, setFilterOpen] = useState(false);

  // Close filter dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.relative')) {
        setFilterOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

    if (showMoreProjects || selectedProject) {
      root.style.overflow = 'hidden';
      root.style.paddingRight = `${scrollBarWidth}px`; // compensate for scrollbar
    } else {
      root.style.overflow = '';
      root.style.paddingRight = '';
    }

    return () => {
      root.style.overflow = '';
      root.style.paddingRight = '';
    };
  }, [showMoreProjects, selectedProject]);

  const handleProjectClick = (project) => setSelectedProject(project);
  const closePopup = () => setSelectedProject(null);
  const closeShowMore = () => setShowMoreProjects(false);

  // Filter projects by category
  const filteredProjects =
    filter === 'all'
      ? projects
      : projects.filter((p) => p.category === filter);

  // For initial grid, limit to 6 filtered projects
  const displayedProjects = filteredProjects.slice(0, 6);

  return (
    <section
      id="recent-works"
      className="min-h-screen py-20 px-4 md:px-10 bg-[#F5F3EF] text-[#4B4033]"
    >
      <div className="mb-6 max-w-5xl mx-auto text-center">
        <h2 className="text-2xl font-bold text-[#5D5044] mb-4">My Recent Works</h2>
      </div>

      <div className="max-w-6xl mx-auto px-4">
        {/* Show More and Filter Buttons */}
        <div className="flex justify-start gap-4 mb-6 pl-2 flex-wrap">
          {/* Show More Button */}
          <motion.button
            onClick={() => setShowMoreProjects(true)}
            whileHover={{
              scale: 1.07,
              transition: { type: 'spring', stiffness: 300 },
            }}
            className="px-4 py-2 bg-[#8C6D5A] hover:bg-[#7B5E4C] text-white text-sm font-semibold rounded-lg cursor-pointer"
            title="Show More Projects"
            type="button"
          >
            Show More
          </motion.button>

          {/* Filter Dropdown */}
          <div className="relative">
            <motion.button
              onClick={() => setFilterOpen((prev) => !prev)}
              whileHover={{
                scale: 1.07,
                transition: { type: 'spring', stiffness: 300 },
              }}
              className="px-4 py-2 bg-[#8C6D5A] hover:bg-[#7B5E4C] text-white text-sm font-semibold rounded-lg cursor-pointer"
              title="Filter Projects"
              type="button"
            >
              Filter
            </motion.button>

            {filterOpen && (
              <div className="absolute left-0 mt-2 w-52 bg-white border border-[#C8B8A8] rounded-md shadow-md z-20">
                {categories.map((cat) => (
                  <button
                    key={cat}
                    onClick={() => {
                      setFilter(cat);
                      setFilterOpen(false);
                    }}
                    className={`block w-full text-left px-4 py-2 text-sm hover:bg-[#F5F3EF] ${
                      filter === cat ? 'bg-[#E9E1D8] font-semibold text-[#7B5E4C]' : 'text-[#4B4033]'
                    }`}
                  >
                    {cat.charAt(0).toUpperCase() + cat.slice(1)}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div
          ref={containerRef}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 md:grid-cols-2 gap-5"
        >
          {displayedProjects.map((project, idx) => (
            <motion.div
              key={idx}
              className="group relative bg-[#E4D9CE] bg-opacity-80 rounded-xl overflow-hidden cursor-pointer border-2 border-[#C8B8A8] w-full max-w-sm aspect-auto mx-auto shadow-md hover:shadow-lg"
              onClick={() => handleProjectClick(project)}
              custom={idx}
              initial="hidden"
              animate={isInView ? 'visible' : 'hidden'}
              variants={fadeMotion}
              whileHover={{ scale: 1.03 }}
              transition={{ type: 'spring', stiffness: 300 }}
            >
              <img
                src={project.img}
                alt={project.title}
                className="w-full h-52 object-cover transition duration-300 group-hover:brightness-50 group-hover:blur-sm"
              />

              {/* Overlay on hover */}
              <motion.div
                className="absolute inset-0 flex flex-col justify-between bg-black bg-opacity-40 text-white p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                initial={{ opacity: 0 }}
                animate={{ opacity: 0 }}
                whileHover={{ opacity: 1 }}
              >
                {/* Floating Label */}
                <div className="absolute top-2 right-2 bg-[#F5F3EF] text-[#4B4033] px-2 py-1 rounded text-xs font-semibold shadow-sm">
                  {project.category.toUpperCase()}
                </div>

                {/* Tech & Description */}
                <div className="mt-auto">
                  <p className="text-sm mb-2 line-clamp-3">{project.description}</p>
                  <div className="flex space-x-2 text-lg flex-wrap">
                    {project.tech.map((icon, i) => (
                      <span key={i} className="inline-block">
                        {icon}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Show More Projects Modal */}
      <AnimatePresence>
        {showMoreProjects && (
          <motion.div
            className="fixed inset-0 z-[100] bg-black bg-opacity-80 backdrop-blur-sm flex items-center justify-center p-5"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeShowMore}
          >
            <motion.div
              className="bg-[#E9E1D8] rounded-2xl p-6 max-w-7xl w-full max-h-[90vh] overflow-y-auto shadow-lg relative"
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={closeShowMore}
                aria-label="Close Show More"
                className="absolute top-3 right-3 p-2 text-[#4B4033] hover:text-[#7B5E4C] font-bold text-xl"
              >
                ×
              </button>

              <h3 className="text-2xl font-semibold text-[#5D5044] mb-6 text-center">All Projects</h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 md:grid-cols-2 gap-6">
                {filteredProjects.map((project, idx) => (
                  <motion.div
                    key={idx}
                    className="group relative bg-[#E4D9CE] bg-opacity-80 rounded-xl overflow-hidden cursor-pointer border-2 border-[#C8B8A8] w-full aspect-auto mx-auto shadow-md hover:shadow-lg"
                    onClick={() => handleProjectClick(project)}
                    whileHover={{ scale: 1.03 }}
                    transition={{ type: 'spring', stiffness: 300 }}
                  >
                    <img
                      src={project.img}
                      alt={project.title}
                      className="w-full h-48 object-cover transition duration-300 group-hover:brightness-50 group-hover:blur-sm"
                    />

                    {/* Overlay on hover */}
                    <motion.div
                      className="absolute inset-0 flex flex-col justify-between bg-black bg-opacity-40 text-white p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 0 }}
                      whileHover={{ opacity: 1 }}
                    >
                      {/* Floating Label */}
                      <div className="absolute top-2 right-2 bg-[#F5F3EF] text-[#4B4033] px-2 py-1 rounded text-xs font-semibold shadow-sm">
                        {project.category.toUpperCase()}
                      </div>

                      {/* Tech & Description */}
                      <div className="mt-auto">
                        <h4 className="font-bold text-lg mb-1">{project.title}</h4>
                        <p className="text-sm mb-2 line-clamp-3">{project.description}</p>
                        <div className="flex space-x-2 text-lg flex-wrap">
                          {project.tech.map((icon, i) => (
                            <span key={i} className="inline-block">
                              {icon}
                            </span>
                          ))}
                        </div>
                      </div>
                    </motion.div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Project Detail Popup */}
      <AnimatePresence>
        {selectedProject && (
          <motion.div
            className="fixed inset-0 z-[110] bg-black bg-opacity-80 backdrop-blur-sm flex items-center justify-center p-5"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closePopup}
          >
            <motion.div
              className="bg-[#E9E1D8] rounded-2xl p-6 max-w-xl max-h-[90vh] overflow-y-auto shadow-lg relative"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={closePopup}
                className="absolute top-3 right-3 p-2 text-[#4B4033] hover:text-[#7B5E4C] font-bold text-xl"
                aria-label="Close"
              >
                &times;
              </button>

              <h3 className="text-[#4B4033] text-2xl font-semibold mb-4">
                {selectedProject.title}
              </h3>
              <img
                src={selectedProject.img}
                alt={selectedProject.title}
                className="w-full max-h-64 object-cover rounded-md mb-4"
              />
              <p className="text-[#4B4033] mb-4">{selectedProject.description}</p>

              <div className="flex justify-between items-center flex-wrap mb-4">
                <div>
                  <div className="font-semibold text-[#7B5E4C] mb-1"></div>
                  <div className="flex space-x-3 text-xl flex-wrap">
                    {selectedProject.tech.map((icon, i) => (
                      <span key={i} className="inline-block">
                        {icon}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex space-x-6 text-[#4B4033] text-xl flex-wrap">
                  {selectedProject.github && (
                    <a
                      href={selectedProject.github}
                      target="_blank"
                      rel="noreferrer"
                      className="hover:text-[#7B5E4C]"
                      title="GitHub Repository"
                    >
                      <FaGithub />
                    </a>
                  )}
                  {selectedProject.live && selectedProject.live !== '#' && (
                    <a
                      href={selectedProject.live}
                      target="_blank"
                      rel="noreferrer"
                      className="hover:text-[#7B5E4C]"
                      title="Live Demo"
                    >
                      <FaExternalLinkAlt />
                    </a>
                  )}
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default RecentWorks;
